export const WIX_APP_URL = {
  IOS: 'itms-apps://apps.apple.com/app/id1099748482',
  ANDROID: 'https://play.google.com/store/apps/details?id=com.wix.android',
};
